import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { fontStyles } from 'elements/_shared/fonts.style.js'
import { CSSResultGroup, html, LitElement, nothing } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { style } from './label.style.js'
import { hasNamedSlot } from 'elements/_shared/hasSlot.js'
import { initializeIconsByRole } from '@cloudsuite/mosaic-shared/icons/library.js'


initializeIconsByRole({
  'cse-label.title': { name: 'circle-info', style: 'regular' },
})

@customElement('cse-label')
export class CSELabel extends LitElement {
  static override styles: CSSResultGroup = [fontStyles, hostStyle, style]

  @property({ type: String })
  for = ''

  @property({ type: Boolean })
  optional = false

  @property({ type: Boolean })
  required = false

  private requiredSlot = () => html`
    <span class="required">
      <slot name="required">
        *
      </slot>
    </span>`

  private optionalSlot = () => html`
    <span class="suffix font-caption-m">
      <slot name="optional">
        Optioneel
      </slot>
    </span>`

  private renderTitleTooltip = () => {
    if (hasNamedSlot(this, 'title')) {
      return html`
        <cse-tooltip>
          <cse-icon
            slot="anchor"
            class="title-icon"
            icon-role="cse-label.title"
          ></cse-icon>
          <slot name="title"></slot>
        </cse-tooltip>
      `
    }
    return nothing
  }

  override render() {
    return html`
      <label class="cse-label font-body-s" for="${this.for}">
        <slot></slot>
        ${this.required ? this.requiredSlot() : nothing}
        ${this.optional ? this.optionalSlot() : nothing}
        ${this.renderTitleTooltip()}
      </label>`
  }
}


declare global {
  interface HTMLElementTagNameMap {
    'cse-label': CSELabel
  }
}
